/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddAddressV2Input = {
  readonly city: string;
  /** 2 letter country code */
  readonly country: string;
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly latitude: number;
  readonly longitude: number;
  readonly name?: string | null | undefined;
  readonly notes?: string | null | undefined;
  readonly secondaryStreet?: string | null | undefined;
  /** 2 letter state code */
  readonly state: string;
  readonly street: string;
  readonly zipCode: string;
};

export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type EditAddressV2Input = {
  readonly city: string;
  /** 2 letter country code */
  readonly country: string;
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly id: string | number;
  readonly latitude: number;
  readonly longitude: number;
  readonly name?: string | null | undefined;
  readonly notes?: string | null | undefined;
  readonly secondaryStreet?: string | null | undefined;
  /** 2 letter state code */
  readonly state: string;
  readonly street: string;
  readonly zipCode: string;
};

export type ValidationErrorResponseFragment = {
  readonly message: string;
  readonly status: number;
  readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
};

export type AddressFormFragment = {
  readonly __typename: 'Address';
  readonly id: string;
  readonly street: string;
  readonly secondaryStreet: string | null;
  readonly name: string | null;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly country: string;
  readonly deliveryPreference: Types.DeliveryPreferenceType;
  readonly latitude: number;
  readonly longitude: number;
  readonly notes: string | null;
};

export type AddAddressMutationVariables = Exact<{
  input: Types.AddAddressV2Input;
}>;

export type AddAddressMutation = {
  readonly addAddressV2:
    | {
        readonly __typename: 'AddAddressSuccess';
        readonly address: {
          readonly __typename: 'Address';
          readonly id: string;
          readonly street: string;
          readonly secondaryStreet: string | null;
          readonly name: string | null;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly country: string;
          readonly deliveryPreference: Types.DeliveryPreferenceType;
          readonly latitude: number;
          readonly longitude: number;
          readonly notes: string | null;
        };
      }
    | { readonly __typename: 'InvalidAddress'; readonly message: string; readonly status: number }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export type UpdateAddressMutationVariables = Exact<{
  input: Types.EditAddressV2Input;
}>;

export type UpdateAddressMutation = {
  readonly updateAddressV2:
    | { readonly __typename: 'InvalidAddress'; readonly message: string; readonly status: number }
    | {
        readonly __typename: 'UpdateAddressSuccess';
        readonly address: {
          readonly __typename: 'Address';
          readonly id: string;
          readonly street: string;
          readonly secondaryStreet: string | null;
          readonly name: string | null;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly country: string;
          readonly deliveryPreference: Types.DeliveryPreferenceType;
          readonly latitude: number;
          readonly longitude: number;
          readonly notes: string | null;
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export type DeleteAddressMutationVariables = Exact<{
  id: string | number;
}>;

export type DeleteAddressMutation = {
  readonly deleteAddress:
    | { readonly __typename: 'DeleteAddressSuccess'; readonly success: boolean }
    | { readonly __typename: 'InvalidAddress'; readonly message: string; readonly status: number }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const ValidationErrorResponseFragmentDoc = gql`
  fragment ValidationErrorResponse on ValidationError {
    message
    status
    fieldErrors {
      field
      message
    }
  }
`;
export const AddressFormFragmentDoc = gql`
  fragment addressForm on Address {
    id
    __typename
    street
    secondaryStreet
    name
    city
    state
    zipCode
    country
    deliveryPreference
    latitude
    longitude
    notes
  }
`;
export const AddAddressDocument = gql`
  mutation addAddress($input: AddAddressV2Input!) {
    addAddressV2(input: $input) {
      __typename
      ... on AddAddressSuccess {
        address {
          id
          __typename
          ...addressForm
        }
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${AddressFormFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useAddAddressMutation() {
  return Urql.useMutation<AddAddressMutation, AddAddressMutationVariables>(AddAddressDocument);
}
export const UpdateAddressDocument = gql`
  mutation updateAddress($input: EditAddressV2Input!) {
    updateAddressV2(input: $input) {
      __typename
      ... on UpdateAddressSuccess {
        address {
          id
          __typename
          ...addressForm
        }
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${AddressFormFragmentDoc}
  ${ValidationErrorResponseFragmentDoc}
`;

export function useUpdateAddressMutation() {
  return Urql.useMutation<UpdateAddressMutation, UpdateAddressMutationVariables>(
    UpdateAddressDocument,
  );
}
export const DeleteAddressDocument = gql`
  mutation deleteAddress($id: ID!) {
    deleteAddress(addressId: $id) {
      __typename
      ... on DeleteAddressSuccess {
        success
      }
      ... on ValidationError {
        ...ValidationErrorResponse
      }
      ... on InvalidAddress {
        message
        status
      }
    }
  }
  ${ValidationErrorResponseFragmentDoc}
`;

export function useDeleteAddressMutation() {
  return Urql.useMutation<DeleteAddressMutation, DeleteAddressMutationVariables>(
    DeleteAddressDocument,
  );
}
